export function parsePosadka(label) {
  if (!label || typeof label !== "string") return [];
  return label
    .split(/[+,]/g) // "A + B" nebo "A,B"
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => s.replace(/\s+/g, " "));
}

export function overlap(aStart, aEnd, bStart, bEnd) {
  return aStart < bEnd && bStart < aEnd;
}

export function intersect(a = [], b = []) {
  const setB = new Set(b);
  return a.filter((x) => setB.has(x));
}
